import { render, staticRenderFns } from "./buy_recognition_page.vue?vue&type=template&id=2674814d&scoped=true"
import script from "./buy_recognition_page.vue?vue&type=script&lang=js"
export * from "./buy_recognition_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674814d",
  null
  
)

export default component.exports